import React, {
    useState,
    useRef,
    useEffect,
    useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import { ErrorBar } from "../../Components/ErrorBar";
import { FtchPlusError, ScenarioUrl_spec, empty_uuid, ftchPlus, getOptions } from "../../App/Account_urls";
import { Box, Paper, Stack } from "@mui/material";
import { moneyFormatter, percent0Formatter } from "../../App/GridFormatters";
import { Help_GisGrid } from "../Help/Help_Grids";
import { GoogleAnalyticsEvent } from "../../Components/ga4";
import { GridHeader } from "../../Components/GridHeader";
import { useCallback } from "react";
import { autoSizeStrategy, columnTypes, onHeaderClicked } from "../../Pages/GridScenario";
import { Arrayify } from "../../Functions/utils";


const cd_Year = {
    headerName: "Year",
    field: "Year",
    sort: "asc",
    width: 75,
    pinned: "left",
    type: "age,rightAligned",
};
const cd_Age = {
    headerName: "Age",
    field: "Age",
    width: 65,
    pinned: "left",
    type: "age,rightAligned",
};
const cd_First6TaxYear = {
    headerName: "Tax Year",
    field: "First6.TaxYear",
    columnGroupShow: "open",
    type: "age,rightAligned",
};
const cd_First6BenefitName = {
    headerName: "Type",
    field: "First6.BenefitName",
    columnGroupShow: "open",
    width: 130,
    type: "age,rightAligned",
};
const cd_First6TableName = {
    headerName: "Name",
    field: "First6.TableName",
    columnGroupShow: "open",
    width: 200,
    type: "age,rightAligned",
};
const cd_First6Income = {
    headerName: "Income",
    field: "First6.Income",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_First6EmpReduction = {
    headerName: "Emp.Red",
    field: "First6.EmpReduction",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};

const cd_First6Max = {
    headerName: "Max",
    field: "First6.Max",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_First6Monthly = {
    headerName: "Benefit",
    field: "First6.Value",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};

const cd_Second6TaxYear = {
    headerName: "Tax Year",
    field: "Second6.TaxYear",
    columnGroupShow: "open",
    type: "age,rightAligned",
};
const cd_Second6BenefitName = {
    headerName: "Type",
    field: "Second6.BenefitName",
    columnGroupShow: "open",
    width: 130,
    type: "age,rightAligned",
};
const cd_Second6TableName = {
    headerName: "Name",
    field: "Second6.TableName",
    columnGroupShow: "open",
    width: 200,
    type: "age,rightAligned",
};
const cd_Second6Income = {
    headerName: "Income",
    field: "Second6.Income",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_Second6EmpReduction = {
    headerName: "Emp.Red",
    field: "Second6.EmpReduction",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};


const cd_Second6Max = {
    headerName: "Max",
    field: "Second6.Max",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_Second6Monthly = {
    headerName: "Benefit",
    field: "Second6.Value",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};




const cd_Benefit = {
    headerName: "Benefit",
    field: "Annual",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};

const cd_Percent = {
    headerName: "% Max",
    field: "PercentMax",
    valueFormatter: percent0Formatter,
    type: "percent,rightAligned",
};


export const gis_columnDefs = [
    cd_Year,
    cd_Age,
    {
        headerName: "First 6 Months",
        groupId: "First 6 Months",
        children: [cd_First6TaxYear, cd_First6Income, cd_First6EmpReduction, cd_First6TableName, cd_First6Max, cd_First6Monthly],
    },
    {
        headerName: "Second 6 Months",
        groupId: "Second 6 Months",
        children: [cd_Second6TaxYear, cd_Second6Income, cd_Second6EmpReduction, cd_Second6TableName, cd_Second6Max, cd_Second6Monthly],
    },
    {
        headerName: "Yearly",
        groupId: "Yearly",
        children: [cd_Benefit, cd_Percent],
    },
];










const GisGrid = ({
    clientJson,
    scen_uuid,
    scen_name,
    width,
    height,
    onClose,
    onExpand,
}) => {
    const gridRef = useRef(null);
    const clientData = useRef(null);
    const topRow = useRef(null);
    const [client, setClient] = useState("");
    const [clients, setClients] = useState([]);
    const [dataSets, setDataSets] = useState([]);
    const [dataSet, setDataSet] = useState("");
    const [rowData, setRowData] = useState();
    const [topRowData, setTopRowData] = useState([]);
    const [bottomRowData, setBottomRowData] = useState([]);
    const [showSums, setShowSums] = useState(false);
    const [loading, setLoading] = useState(true)

    const [errmsg, setErrmsg] = useState("")

    const defaultColDef = useMemo(() => ({
        field: "",
        sortable: false,
        resizable: true,
        suppressMovable: true,
        editable: false,
        width: 100,
        type: "rightAligned",
    }));




    const getData = async () => {
        setLoading(true)
        console.log(clientJson);
        if (scen_uuid && scen_uuid !== empty_uuid) {
            console.log(clientJson.Scenario);
            GoogleAnalyticsEvent("grid", "view", "gis", { action: "view", type: "gis" })

            var url = ScenarioUrl_spec(clientJson, scen_uuid, "gis", "");
            ftchPlus(url, getOptions)
                .then((json) => {
                    console.log(json);
                    clientData.current = json.ClientData;
                    topRow.current = json.TopRow
                    setClients(json.Clients);
                    setDataSets(json.DataSets);
                    const cl = json.Clients[0];
                    setClient(cl);
                    const ds = json.DataSets[0];
                    setDataSet(ds);
                    Update(cl, ds);
                    setLoading(false)
                })
                .catch((error) => {
                    console.log(error.message);
                    setErrmsg(error.message)
                    FtchPlusError(error)
                    setLoading(false)
                });
        }
    };

    const btnClientChanged = (value) => {
        setClient(value);
        Update(value, dataSet);
    };

    const btnDataSetChanged = (value) => {
        setDataSet(value);
        Update(client, value);
    };

    // load data from sever
    useEffect(() => {
        setErrmsg("")
        getData();
    }, [clientJson]);

    const onShowSums = (n, v) => {
        setShowSums(v)
        setTopRowData([])
        setBottomRowData([])

        updateSums(v, client, dataSet)
    }

    const updateSums = (show, cl, ds) => {
        if (show) {
            if (topRow.current) {
                topRow.current[cl][ds][0].Year = "Aggregate"
                topRow.current[cl][ds][0].Age = ""
                setTopRowData(Arrayify(topRow.current[cl][ds]));
            }
        }
    }


    const displayShowSums = () => {
        if (topRow.current) {
            return onShowSums
        }
        return null
    }


    const Update = (cl, ds) => {

        //setColumnDefs(clientData.current[cl][ds].Headers);
        setRowData(clientData.current[cl][ds]);
        updateSums(showSums, cl, ds)
    };
    const onRowDataUpdated = useCallback((event) => {
        event.api.autoSizeAllColumns();
    }, []);

    const gridRefFn = () => {
        return gridRef
    }

    return (
        <Paper>
            <Box sx={{ p: 4 }}>
                <Stack spacing={4}>
                    <GridHeader
                        name={"GIS Calculations"}
                        clientJson={clientJson}
                        scenName={scen_name}
                        clients={clients}
                        client={client}
                        onClientChange={btnClientChanged}
                        dataSets={dataSets}
                        dataSet={dataSet}
                        onDataSetChange={btnDataSetChanged}
                        onExpand={onExpand}
                        onClose={onClose}
                        gridRefFn={gridRefFn}
                        showSums={showSums}
                        onShowSums={displayShowSums()}
                    />

                    <div
                        className="ag-theme-alpine"
                        style={{
                            width: "100%", height: height
                        }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData} // Row Data for Rows
                            pinnedTopRowData={topRowData}
                            pinnedBottomRowData={bottomRowData}
                            rowHeight={32}
                            columnDefs={gis_columnDefs} // Column Defs for Columns
                            defaultColDef={defaultColDef} // Default Column Properties
                            columnTypes={columnTypes}
                            tooltipShowDelay={1200}
                            // animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                            //suppressCellSelection={true}
                            //rowSelection= {mode="singleRow"}
                            onRowDataUpdated={onRowDataUpdated}
                            autoSizeStrategy={autoSizeStrategy}
                            autoSizePadding={8}
                            onColumnHeaderClicked={onHeaderClicked}
                            loading={loading}


                        // onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                        // overlayNoRowsTemplate={none}
                        />
                    </div>
                    <Help_GisGrid />
                    <ErrorBar error={errmsg} />
                </Stack>
            </Box>
        </Paper >
    );
};

export default GisGrid;
